//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _doingEdit_order_order from './doingEdit_order_order';
import _doingFind_order_order from './doingFind_order_order';
import _doingRecreate_order_order from './doingRecreate_order_order';
import _doingView_order_order from './doingView_order_order';
import * as _locationMerge from './locationMerge';
import * as _orderStatus from './orderStatus';
import _willUpdate_order_order from './willUpdate_order_order';
export const doingEdit_order_order = _doingEdit_order_order;
export const doingFind_order_order = _doingFind_order_order;
export const doingRecreate_order_order = _doingRecreate_order_order;
export const doingView_order_order = _doingView_order_order;
export const locationMerge = _locationMerge;
export const orderStatus = _orderStatus;
export const willUpdate_order_order = _willUpdate_order_order;
export default {doingEdit_order_order, doingFind_order_order, doingRecreate_order_order, doingView_order_order, locationMerge, orderStatus, willUpdate_order_order};

